import React from 'react'
import { currencyFormate } from '../Date_Formate_Utilitiy/Index'

const Total_Amount_Row = ({data}) => {
  return (
    <div className="col-6 m-0 p-0 ps-1 text-start">
    <div
      className="col-3 pe-1 lab_voucher_entry align-self-end text-end border_2_2px_top border_2_1px_bottom ms-auto"
      style={{ height: 19.5 }}
    >
      {data?.total_amount===0?"": currencyFormate(data?.total_amount)}
    </div>
  </div>
  )
}

export default Total_Amount_Row
